import { render, staticRenderFns } from "./OpenPlatformTab.vue?vue&type=template&id=5c3c0f2b&scoped=true"
import script from "./OpenPlatformTab.vue?vue&type=script&lang=js"
export * from "./OpenPlatformTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c0f2b",
  null
  
)

export default component.exports